<template>
  <div>

    <Subsidiary :parentCompany="parentCompany"/>

  </div>
</template>

<script>
  import Subsidiary from '@/components/company/Subsidiary'

  export default {
    components: { Subsidiary },
    name: 'Container',
    props: {
      parentCompany: { required: true, type: Object }
    },
  }
</script>

<style scoped>
.card{
  height: 100%;
}

p{
  color: var(--primary-text-color);
}

.table td{
  vertical-align: middle;
}
</style>
